<template>
  <div class="leftContent">
    <!-- 头部 -->
    <v-header v-bind="$attrs" />
    <v-tree />
  </div>
</template>

<script>
import HeaderVue from './Header.vue';
import TreeContentVue from './TreeContent.vue';
export default {
  components: {
    'v-header': HeaderVue,
    'v-tree': TreeContentVue
  }
}
</script>

<style lang="scss" scoped>
.leftContent {
  width: 300px;
  height: 100%;
  margin-right: 15px;
  border-right: 1px solid $borderColor3;
  box-sizing: border-box;
  background-color: #fff;
}
</style>